import { StundenbewertungInputBlock } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/StundenbewertungInputBlock';
import { StundenbewertungToggle } from '@/domain/mitarbeiter/features/anlageassistent/content/Abwesenheiten/Stundenbewertung/StundenbwertungToggle';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { stundenBewertung } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/stundenBewertung';
import { Body, Heading } from '@e2n/ui/v2';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function StundenbewertungBlock() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const { ctx } = useAnlageassistentContext();

  const {
    bezahlungsart: { art },
    arbeitszeitkonto: {
      arbeitstage,
      gehaltsempfaenger: { stundenpensum },
    },
  } = form.state.values.bezahlung;

  const arbeitstageSelected = arbeitstage.length > 0;
  const onlyFesteStundenbewertung =
    (arbeitstageSelected && art === 'fixgehalt') ||
    (art === 'fixgehalt' && stundenpensum === 'woche');

  // muss über useEffect gesetzt werden weil das Field in diesem Fall nicht gerendert wird
  useEffect(() => {
    if (onlyFesteStundenbewertung) {
      form.setFieldValue(
        'abwesenheiten.allgemein.stundenBewertung',
        stundenBewertung.fest,
      );
      ctx.resetDependentFields('abwesenheiten.allgemein.dynamisch');
    }
  }, [onlyFesteStundenbewertung, form, ctx]);

  return (
    <div className="flex flex-col gap-6">
      {!onlyFesteStundenbewertung && (
        <>
          <div className="flex flex-col gap-3">
            <Heading>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.title',
              )}
            </Heading>
            <Body>
              {t(
                'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stundenbewertung.description',
              )}
            </Body>
          </div>
          <StundenbewertungToggle
            onlyFesteStundenbewertung={onlyFesteStundenbewertung}
          />
        </>
      )}
      <StundenbewertungInputBlock />
    </div>
  );
}
